/**
 * API Endpoints Configuration
 * 
 * This file centralizes all API endpoint URLs to make them easier to manage and update.
 * The base API URL is determined from the environment variable REACT_APP_API_URL,
 * defaulting to 'https://api.nostai.com' if not provided.
 */

// Get the base API URL from environment variables or use the default
const BASE_API_URL = 'https://my-fastapi-app-289455571528.us-central1.run.app';

// API endpoint definitions
export const API_ENDPOINTS = {
    // Process a T-shirt image
    PROCESS_TSHIRT: `${BASE_API_URL}/process_tshirt`,
    
    // Generate a quilt layout
    GENERATE_QUILT: `${BASE_API_URL}/generate_quilt`,
    
    // Get AI-suggested layouts
    AI_SUGGESTIONS: `${BASE_API_URL}/ai-suggestions`,
    
    // Generate multiple layout options
    GENERATE_LAYOUTS: `${BASE_API_URL}/generate-layouts`,
    
    // New endpoint for processing embossed images with background removal
    PROCESS_EMBOSS_IMAGE: `${BASE_API_URL}/process_emboss_image`,

    // New endpoint for sample/demo image processing
    PROCESS_DEMO_IMAGE: `${BASE_API_URL}/process_demo_image`
};
